<template>
  <div :class="['yxtbiz-comment__images', this.disabled ? 'yxtbiz-comment__images--disabled' : '']">
    <yxtf-popover
      placement="bottom-start"
      width="256"
      trigger="click"
      popper-class="yxtbiz-comment__images-popper"
      :disabled="disabled"
      v-model="popVisible"
    >
      <span
        slot="reference"
        class="yxtbiz-comment__img-icon hover-primary-6"
        :class="{'color-primary-6 is-active': popVisible}"
      >
        <yxt-svg
          width="14px"
          height="14px"
          icon-class="comment_img"
          :class="projName==='bbs' && files.length>0?'lengthColor':''"
          :remote-url='mediaPath'
        ></yxt-svg>
        <span
          :class="projName==='bbs' && files.length>0?'lengthColor':''"
          class="ml8 color-gray-9"
        >{{$t('pc_biz_comment_add')}}</span>
        <span
          v-if="projName==='bbs' && files.length>0"
          class="color-primary-5"
        >({{ files.length }}) </span>
        <!-- 删除图标 -->
        <yxtf-svg
          v-if="projName==='bbs' && files.length > 0"
          class="ml5 a-link-hover"
          width="16px"
          height="16px"
          icon-class="delete"
          @click.native="handleDelete"
        />
      </span>
      <div class="yxtbiz-comment__image-list">
        <h4 class="yxtbiz-comment__pop-title"><span>{{$t('pc_biz_comment_upload')}}</span></h4>
        <p class="mb8 yxtbiz-comment__pop-num">{{$t('pc_biz_comment_upload_count', [count])}} <span class="color-primary-6">{{rest}}</span> {{$t('pc_biz_comment_unit')}}</p>
        <div class="overflow-hidden">
          <div
            v-for="img in files"
            :key="img.uuid"
            class="yxtbiz-comment__image float-left"
          >
            <!-- 社区上传图片样式修改 -->
            <yxtf-image
              :class="projName==='bbs'?'bbs_image_Class':''"
              :src="img.url"
              :fit="fitClass"
            ></yxtf-image>
            <i
              class="yxtbiz-comment__close"
              @click="removeImage(img.url, img.uuid)"
            >
              <yxt-svg
                width="8px"
                height="8px"
                icon-class="comment_close"
                :remote-url='mediaPath'
                @click="removeImage(img.url, img.uuid)"
              ></yxt-svg>
            </i>
          </div>
          <yxtbiz-upload
            class="yxtbiz-comment__image float-left"
            ref="bizUpload"
            v-show="rest > 0"
            :config-key="options.configKey"
            :module-name="options.moduleName"
            :function-name="options.functionName"
            :appCode="options.appCode"
            :before-upload="beforeUpload"
            :on-progress="onProgress"
            :on-uploaded="onUploaded"
            :on-error="onError"
            :files-added="filesAdded"
            :file-filtered="oversize"
            version="v2"
            scene-code="bbs"
            multipe
            :max-size="options.size"
          >
            <div class="border-primary-6">
              <div class="yxtbiz-comment__upload-icon hover-primary-6">
                <yxt-svg
                  width="16px"
                  height="16px"
                  icon-class="comment_pls"
                  @click="removeImage(img.url, img.uuid)"
                  :remote-url='mediaPath'
                ></yxt-svg>
              </div>
            </div>
            <!-- <div class="yxtbiz-comment__upload-icon"><i class="yxt-icon-plus"></i></div> -->
          </yxtbiz-upload>
        </div>
      </div>
    </yxtf-popover>
  </div>
</template>

<script>
import YxtbizUpload from 'yxt-biz-pc/packages/upload';
import {
  FrontImage,
  FrontPopover,
  FrontButton
} from 'yxt-pc';
import { getMedia } from 'yxt-biz-pc/packages/api';
// import { Api } from 'yxt-biz-pc-base';
// const { getMedia } = Api

export default {
  name: 'YxtbizComment',
  components: {
    YxtbizUpload, YxtfImage: FrontImage,
    YxtfPopover: FrontPopover,
    YxtfButton: FrontButton
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    projName: {
      type: String,
      default: ''
    },
    uploadOptions: {}
  },
  data() {
    return {
      popVisible: false,
      defaultOptions: {
        max: 9,
        size: 5 * 1024,
        configKey: 'ImageConfigKey',
        moduleName: 'test_module',
        functionName: 'test_function',
        appCode: 'bbs',
        filter: 'png,gif,jpg,bmp,jpeg'
      },
      files: [],
      uploadStatus: {} // 所有上传的图片的状态 0 start, 1 end
    };
  },
  computed: {
    fitClass() {
      return this.projName === 'bbs' ? 'contain' : 'cover';
    },
    rest() {
      return this.options.max - this.count;
    },
    options() {
      return { ...this.defaultOptions, ...this.uploadOptions };
    },
    count() {
      return this.files.length;
    },
    mediaPath() {
      return getMedia() + 'common/biz_svg';
    }
  },
  methods: {
    handleDelete() {
      this.files = [];
      this.uploadStatus = {};
    },
    beforeUpload(file) {
      let uuids = Object.keys(this.uploadStatus);
      if (uuids.length === this.options.max) {
        return false;
      }
      if (file.uuid) {
        this.uploadStatus[file.uuid] = 0;
      }
    },
    onProgress(file, progress, event) {
      const f = this.getFile(file.uuid);
      if (f) {
        f.percentage = progress.toFixed(2) * 100;
      }
    },
    onUploaded(file) {
      if (this.files.length === this.options.max) {
        return false;
      }
      this.files.push({
        uuid: file.uuid,
        name: file.name,
        url: file.fullUrl,
        id: file.id
      });
      if (file.uuid) {
        this.uploadStatus[file.uuid] = 1;
      }
    },
    onError(error, file) {
      if (file.uuid) {
        delete this.uploadStatus[file.uuid];
      }
      if (document.getElementsByClassName('yxt-message').length === 0) {
        this.$message.error('error', error);
      }
    },
    getFile(uuid) {
      for (const f of this.files) {
        if (f.uuid === uuid) {
          return f;
        }
      }
    },
    filesAdded(files) {
      for (let i = 0; i < files.length; i++) {
        if (files[i].error === 'oversize') {
          this.oversize();
          break;
        }
        if (files[i].error === 'forbidden') {
          this.$message.error(this.$t('pc_biz_comment_upload_imageonly'));
          break;
        }
      }
    },
    oversize(e) {
      this.$message.error(this.$t('pc_biz_comment_upload_oversize'));
    },
    removeImage(url, uuid) {
      if (uuid) {
        delete this.uploadStatus[uuid];
      }
      this.files = this.files.filter(v => v.url !== url);
    },
    closePop() {
      this.popVisible = false;
    },
    showPop() {
      this.popVisible = true;
    },
    getImages() {
      return this.files;
    },
    setImages(images) {
      let imagesTemp = images.map(image => {
        if (typeof image === 'string') {
          return {
            url: image
          };
        }
        if (typeof image === 'object') {
          return image;
        }
      });
      this.files = imagesTemp;
      this.uploadStatus = {};
    },
    checkStatus() {
      let status = true;
      for (let uuid in this.uploadStatus) {
        if (this.uploadStatus[uuid] === 0) {
          status = false;
          break;
        }
      }
      return status;
    }
  }
};
</script>
